module.exports = __webpack_public_path__ + "img/standard2.ff551b7.png";